export default __webpack_public_path__ + "static/media/7G.4a277a6d.png";